export default {
    namespaced: true,
    state: {
        list: [
            {
                label: 'Расчет с клиентом (физ. лицо)',
                value: 1,
            },
            {
                label: 'Расчет с клиентом (юр. лицо)',
                value: 2,
            },
            {
                label: 'Расчет с оператором',
                value: 3,
            },
            {
                label: 'Расчет с партнером/поставщиком (физ. лицо)',
                value: 5,
            },
            {
                label: 'Расчет с партнером/поставщиком (юр. лицо)',
                value: 6,
            },
            {
                label: 'Расчет с центром бронирования',
                value: 7,
            },
        ],
        load: false,
    },
    getters: {
        list: (state, getters, rootState, rootGetters) => (id, reservation = false, allow = false) => {
            if (id && rootGetters['dictionary/paymentOperation/getById']) {
                let operation = rootGetters['dictionary/paymentOperation/getById'](id);
                return state.list.filter(i => {
                    switch (i.value) {
                        case 1:
                        case 2:
                            if (id === 5) return false;
                            if (id === 6) return false;
                            if (id === 9) return false;
                            if (id === 10) return false;
                            return !!operation.OperationType && !allow;
                        case 3:
                            if (id === 1) return false;
                            if (id === 2) return false;
                            if (id === 3) return false;
                            if (id === 4) return false;
                            if (id === 7) return false;
                            if (id === 8) return false;
                            return !!operation.OperationType;
                        case 5:
                        case 6:
                            return !operation.OperationType;
                        case 7:
                            return !!operation.OperationType && reservation;
                    }
                });
            } else {
                return id ? [] : state.list;
            }
        },
        listPermission: (state, getters, rootState, rootGetters) => (id, reservation = false, allow = false) => {
            let permission = rootGetters.permission;
            if (id && rootGetters['dictionary/paymentOperation/getById']) {
                let operation = rootGetters['dictionary/paymentOperation/getById'](id);
                return state.list.filter(i => {
                    switch (i.value) {
                        case 1:
                        case 2:
                            if (!permission(48)) return false;
                            if (id === 5) return false;
                            if (id === 6) return false;
                            if (id === 9) return false;
                            if (id === 10) return false;
                            return !!operation.OperationType && !allow;
                        case 3:
                            if (!permission(49)) return false;
                            if (id === 1) return false;
                            if (id === 2) return false;
                            if (id === 3) return false;
                            if (id === 4) return false;
                            if (id === 7) return false;
                            if (id === 8) return false;
                            return !!operation.OperationType;
                        case 5:
                        case 6:
                            return !operation.OperationType;
                        case 7:
                            return !!operation.OperationType && reservation;
                    }
                });
            } else {
                return id ? [] : state.list;
            }
        },
    }
}